import { baseApi } from "./baseAPI"
import About from "../dtos/about/about";

export const aboutApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getAbout: build.query<About, void>({
            query: () => "about"
            ,
            // Cache for id
            providesTags: (_result, _error, brand) => [{ type: 'about', value: "all"}],
            // transformResponse: (rawResult: Promotion, meta) => fixDates(rawResult)
        })
    }),
    overrideExisting: false,
})

export const {
   useGetAboutQuery
} = aboutApi
